enum AppointmentTypeEnum {
  PHONE = 'Ligação',
  SMS = 'Mensagem',
  VIDEO = 'Videochamada',
  PRESENTIAL = 'Presencial',
}

export default AppointmentTypeEnum;
